export const ROLE: Record<string, string> = {
  'TECHNICIAN': 'Técnico',
  'ADMIN': 'Administrador',
  'SUPER_ADMIN': 'Super Administrador',
  'RECEPTIONIST': 'Recepcionista',
};

// Roles de la base de datos
export enum RoleEnum {
  TECHNICIAN = 'TECHNICIAN',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  RECEPTIONIST = 'RECEPTIONIST',
}

// Configuración de acceso por ruta
export const ROLE_ACCESS: Record<string, RoleEnum[]> = {
  'reception': [RoleEnum.ADMIN, RoleEnum.SUPER_ADMIN, RoleEnum.RECEPTIONIST],
  'technical': [RoleEnum.ADMIN, RoleEnum.SUPER_ADMIN, RoleEnum.TECHNICIAN],
  'admin': [RoleEnum.ADMIN, RoleEnum.SUPER_ADMIN],
  'sales': [RoleEnum.ADMIN, RoleEnum.SUPER_ADMIN], // Cotizaciones
  'system': [RoleEnum.ADMIN, RoleEnum.SUPER_ADMIN], // Administración
};
